import { makeObservable, observable, action } from "mobx";

import {
  unReadNotifyCount,
  pageQueryMsg,
  switchReadState,
  queryNotice,
} from "utils/api";

// 头部store
export default class HeaderStore {
  notifyCount = 0;
  notifyList = [];
  noticeList = [];

  constructor() {
    makeObservable(this, {
      notifyCount: observable,
      notifyList: observable,
      noticeList: observable,
      unReadNotifyCount: action,
      pageQueryMsg: action,
      queryNotice: action,
      switchReadState: action,
    });
  }
  async unReadNotifyCount() {
    const res = await unReadNotifyCount({});
    if (res.data.success) {
      this.notifyCount = res.data.result;
    }
  }
  async pageQueryMsg(data) {
    const res = await pageQueryMsg(data);
    if (res.data.success) {
      this.notifyList = res.data.result.items;
    }
  }
  async queryNotice(data) {
    const res = await queryNotice(data);
    if (res.data.success) {
      this.noticeList = res.data.result.items;
    }
  }
  async switchReadState() {
    await switchReadState({});
  }
}
